import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IJobOrderOwner, defaultValue } from 'app/shared/model/job-order-owner.model';

export const ACTION_TYPES = {
  FETCH_JOBORDEROWNER_LIST: 'jobOrderOwner/FETCH_JOBORDEROWNER_LIST',
  FETCH_JOBORDEROWNER: 'jobOrderOwner/FETCH_JOBORDEROWNER',
  CREATE_JOBORDEROWNER: 'jobOrderOwner/CREATE_JOBORDEROWNER',
  UPDATE_JOBORDEROWNER: 'jobOrderOwner/UPDATE_JOBORDEROWNER',
  DELETE_JOBORDEROWNER: 'jobOrderOwner/DELETE_JOBORDEROWNER',
  RESET: 'jobOrderOwner/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IJobOrderOwner>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type JobOrderOwnerState = Readonly<typeof initialState>;

// Reducer

export default (state: JobOrderOwnerState = initialState, action): JobOrderOwnerState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_JOBORDEROWNER_LIST):
    case REQUEST(ACTION_TYPES.FETCH_JOBORDEROWNER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_JOBORDEROWNER):
    case REQUEST(ACTION_TYPES.UPDATE_JOBORDEROWNER):
    case REQUEST(ACTION_TYPES.DELETE_JOBORDEROWNER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_JOBORDEROWNER_LIST):
    case FAILURE(ACTION_TYPES.FETCH_JOBORDEROWNER):
    case FAILURE(ACTION_TYPES.CREATE_JOBORDEROWNER):
    case FAILURE(ACTION_TYPES.UPDATE_JOBORDEROWNER):
    case FAILURE(ACTION_TYPES.DELETE_JOBORDEROWNER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_JOBORDEROWNER_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_JOBORDEROWNER):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_JOBORDEROWNER):
    case SUCCESS(ACTION_TYPES.UPDATE_JOBORDEROWNER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_JOBORDEROWNER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/job-order-owners';

// Actions

export const getEntities: ICrudGetAllAction<IJobOrderOwner> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_JOBORDEROWNER_LIST,
  payload: axios.get<IJobOrderOwner>(`${apiUrl}?cacheBuster=${new Date().getTime()}`)
});

export const getEntity: ICrudGetAction<IJobOrderOwner> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_JOBORDEROWNER,
    payload: axios.get<IJobOrderOwner>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IJobOrderOwner> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_JOBORDEROWNER,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IJobOrderOwner> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_JOBORDEROWNER,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IJobOrderOwner> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_JOBORDEROWNER,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
